const e = {
  lightMode: {
    text: {
      primary: {
        value: "#222222",
        type: "color",
        description: "Text primary"
      },
      secondary: {
        value: "#707071",
        type: "color",
        description: "Text secondary - For use on grey shades (level 1, grey 50, grey 100 etc)"
      },
      tertiary: {
        value: "#A9A9AA",
        type: "color",
        description: "For use on white / level 3"
      },
      disabled: {
        value: "#c6c6c6",
        type: "color"
      },
      link: {
        value: "#2196f3",
        type: "color"
      },
      body: {
        value: "#323232",
        type: "color"
      }
    },
    primary: {
      main: {
        value: "#0F4B4A",
        type: "color"
      },
      light: {
        value: "#2C8B8B",
        type: "color",
        description: "Alternative light shade"
      },
      dark: {
        value: "#253C44",
        type: "color"
      },
      main30: {
        value: "#B7C9C9",
        type: "color",
        description: "Fill background for contained variant components in hover state."
      },
      contrast: {
        value: "#ffffff",
        type: "color",
        description: "Color that keeps a contrast ratio above AA when XX.main is used as a bg. color"
      },
      main08: {
        value: "#ECF1F1",
        type: "color",
        description: "Fill background color for outlined & text variant components in hover state (Button, etc)"
      }
    },
    secondary: {
      main: {
        value: "#393939",
        type: "color",
        description: "Secondary color used by most components"
      },
      light: {
        value: "#6b6b6b",
        type: "color",
        description: "Alternative light shade"
      },
      dark: {
        value: "#1b1b1b",
        type: "color",
        description: "Alternative dark shade"
      },
      contrast: {
        value: "#ffffff",
        type: "color",
        description: "Color that keeps a contrast ratio above AA when XX.main is used as a bg. color"
      },
      main30: {
        value: "#C4C4C4",
        type: "color",
        description: "Fill background for contained variant components in hover state (Button, FAB, etc)"
      },
      main08: {
        value: "#EFEFEF",
        type: "color",
        description: "Fill background color for outlined & text variant components in hover state (Button, etc)"
      }
    },
    background: {
      level1: {
        value: "#F8F8F8",
        type: "color"
      },
      level2: {
        value: "#EFEFEF",
        type: "color"
      },
      level3: {
        value: "#FFFFFF",
        type: "color"
      },
      level4: {
        value: "#F0F0F0",
        type: "color"
      },
      white: {
        value: "#ffffff",
        type: "color"
      },
      black: {
        value: "#000000",
        type: "color"
      }
    },
    grey: {
      50: {
        value: "#F9F9F9",
        type: "color"
      },
      100: {
        value: "#f5f5f5",
        type: "color"
      },
      200: {
        value: "#eeeeee",
        type: "color"
      },
      300: {
        value: "#e0e0e0",
        type: "color"
      },
      400: {
        value: "#bdbdbd",
        type: "color"
      },
      500: {
        value: "#9e9e9e",
        type: "color"
      },
      600: {
        value: "#757575",
        type: "color"
      },
      700: {
        value: "#616161",
        type: "color"
      },
      800: {
        value: "#424242",
        type: "color"
      },
      900: {
        value: "#212121",
        type: "color"
      }
    },
    info: {
      main: {
        value: "#2196f3",
        type: "color",
        description: "Used for alert component"
      },
      light: {
        value: "#64b6f7",
        type: "color",
        description: "Alternative light shade"
      },
      dark: {
        value: "#0b79d0",
        type: "color",
        description: "Alternative dark shade"
      },
      contrast: {
        value: "#ffffff",
        type: "color",
        description: "Color that keeps a contrast ratio above AA when XX.main is used as a bg. color"
      },
      main30: {
        value: "#BCDFFB",
        type: "color",
        description: "Fill background color for contained variant components in hover state (Button, FAB, etc)"
      },
      main08: {
        value: "#EDF7FE",
        type: "color",
        description: "Used for outlined variant components in resting state (Button, Chip, etc)"
      }
    },
    success: {
      main: {
        value: "#4CA450",
        type: "color",
        description: "Used for alert component"
      },
      dark: {
        value: "#3b873e",
        type: "color",
        description: "Alternative dark shade"
      },
      light: {
        value: "#7bc67e",
        type: "color",
        description: "Alternative light shade"
      },
      contrast: {
        value: "#ffffff",
        type: "color",
        description: "Color that keeps a contrast ratio above AA when XX.main is used as a bg. color"
      },
      main30: {
        value: "#C9E4CA",
        type: "color",
        description: "Fill background color for contained variant components in hover state (Button, FAB, etc)"
      },
      main08: {
        value: "#F1F8F1",
        type: "color",
        description: "Used for outlined variant components in resting state (Button, Chip, etc)"
      }
    },
    warning: {
      main: {
        value: "#D67A2D",
        type: "color",
        description: "Used for alert component (изменил)"
      },
      dark: {
        value: "#BC6514",
        type: "color",
        description: "Alternative dark shade"
      },
      light: {
        value: "#FB9540",
        type: "color",
        description: "Alternative light shade"
      },
      contrast: {
        value: "#ffffff",
        type: "color",
        description: "Color that keeps a contrast ratio above AA when XX.main is used as a bg. color"
      },
      main30: {
        value: "#F3D7C0",
        type: "color",
        description: "Fill background color for contained variant components in hover state (Button, FAB, etc)"
      },
      main08: {
        value: "#FCF4EE",
        type: "color",
        description: "Used for outlined variant components in resting state (Button, Chip, etc)"
      }
    },
    error: {
      main: {
        value: "#f44336",
        type: "color",
        description: "Used for alert component"
      },
      dark: {
        value: "#e31b0c",
        type: "color",
        description: "Alternative dark shade"
      },
      light: {
        value: "#f88078",
        type: "color",
        description: "Alternative light shade"
      },
      contrast: {
        value: "#ffffff",
        type: "color",
        description: "Color that keeps a contrast ratio above AA when XX.main is used as a bg. color"
      },
      main30: {
        value: "#FCC7C3",
        type: "color",
        description: "Fill background color for contained variant components in hover state (Button, FAB, etc)"
      },
      main08: {
        value: "#FEF0EF",
        type: "color",
        description: "Fill background color for outlined & text variant components in hover state (Button, etc)"
      }
    },
    other: {
      divider: {
        value: "#00000015",
        type: "color",
        description: "Divider fill color"
      },
      outlinedBorder: {
        value: "#00000023",
        type: "color",
        description: "Border style for outlined variant components in resting state (Text Field, Select, Chips, etc)"
      },
      backdropOverlay: {
        value: "#00000050",
        type: "color",
        description: "Backdrop overlay style"
      },
      filledInputBackground: {
        value: "#00000009",
        type: "color"
      },
      standardInputLine: {
        value: "#00000042",
        type: "color",
        description: "Border style for standard variant Text Field & Select"
      },
      snackbarBackground: {
        value: "#323232",
        type: "color",
        description: "Snackbar background color"
      },
      ratingActive: {
        value: "#ffb400",
        type: "color",
        description: "Active state color for Rating component"
      }
    },
    action: {
      active: {
        value: "#A0A0A0",
        type: "color",
        description: "Fill color for components in active state (List, Table, etc)"
      },
      hover: {
        value: "#00000004",
        type: "color",
        description: "Fill background for components in hover state (List, Table, etc)"
      },
      selected: {
        value: "#00000008",
        type: "color",
        description: "Fill background for components in selected state (List, Table, etc)"
      },
      disabled: {
        value: "#00000015",
        type: "color",
        description: "Content color for components in disabled state (Button, List, Table, etc)"
      },
      disabledBackground: {
        value: "#00000015",
        type: "color",
        description: "Fill background for components in disabled state (List, Table, etc)"
      },
      focus: {
        value: "#00000012",
        type: "color",
        description: "Fill background for components in focus state (List, Table, etc)"
      }
    }
  },
  darkMode: {
    text: {
      primary: {
        value: "#f9fbfa",
        type: "color",
        description: "Text primary"
      },
      secondary: {
        value: "#CBCBCB",
        type: "color",
        description: "Text secondary"
      },
      tertiary: {
        value: "#adadad",
        type: "color"
      },
      disabled: {
        value: "#565656",
        type: "color"
      },
      body: {
        value: "#ffffff",
        type: "color"
      },
      link: {
        value: "#2196f3",
        type: "color"
      }
    },
    primary: {
      main: {
        value: "#8980ff",
        type: "color"
      },
      dark: {
        value: "#594dff",
        type: "color"
      },
      light: {
        value: "#b8b2ff",
        type: "color"
      },
      contrast: {
        value: "#171717",
        type: "color"
      },
      main08: {
        value: "#8980FF08",
        type: "color"
      },
      main30: {
        value: "#8980FF30",
        type: "color"
      }
    },
    secondary: {
      main: {
        value: "#cdcdcd",
        type: "color"
      },
      light: {
        value: "#f0f0f0",
        type: "color"
      },
      dark: {
        value: "#c4c4c4",
        type: "color"
      },
      contrast: {
        value: "#171717",
        type: "color"
      },
      main08: {
        value: "#cdcdcd08",
        type: "color"
      },
      main30: {
        value: "#CDCDCD30",
        type: "color"
      }
    },
    other: {
      divider: {
        value: "#ffffff15",
        type: "color"
      },
      outlinedBorder: {
        value: "#3b3b3b",
        type: "color"
      },
      backdropOverlay: {
        value: "#00000050",
        type: "color"
      },
      filledInputBackground: {
        value: "#ffffff08",
        type: "color"
      },
      standardInputLine: {
        value: "#333333",
        type: "color"
      },
      snackbarBackground: {
        value: "#d9d9d9",
        type: "color"
      },
      ratingActive: {
        value: "#eba000",
        type: "color"
      }
    },
    action: {
      active: {
        value: "#ffffff40",
        type: "color"
      },
      hover: {
        value: "#ffffff04",
        type: "color"
      },
      selected: {
        value: "#ffffff08",
        type: "color"
      },
      disabled: {
        value: "#ffffff20",
        type: "color"
      },
      disabledBackground: {
        value: "#ffffff15",
        type: "color"
      },
      focus: {
        value: "#ffffff12",
        type: "color"
      }
    },
    grey: {
      50: {
        value: "#212121",
        type: "color"
      },
      100: {
        value: "#424242",
        type: "color"
      },
      200: {
        value: "#616161",
        type: "color"
      },
      300: {
        value: "#757575",
        type: "color"
      },
      400: {
        value: "#9e9e9e",
        type: "color"
      },
      500: {
        value: "#bdbdbd",
        type: "color"
      },
      600: {
        value: "#e0e0e0",
        type: "color"
      },
      700: {
        value: "#eeeeee",
        type: "color"
      },
      800: {
        value: "#f5f5f5",
        type: "color"
      },
      900: {
        value: "#fafafa",
        type: "color"
      }
    },
    info: {
      main: {
        value: "#1c93f3",
        type: "color"
      },
      light: {
        value: "#56aff6",
        type: "color"
      },
      dark: {
        value: "#0b79d0",
        type: "color"
      },
      contrast: {
        value: "#171717",
        type: "color"
      },
      main08: {
        value: "#3DA3F508",
        type: "color"
      },
      main30: {
        value: "#1c93f330",
        type: "color"
      }
    },
    success: {
      main: {
        value: "#5bb85f",
        type: "color"
      },
      dark: {
        value: "#449d48",
        type: "color"
      },
      light: {
        value: "#71c174",
        type: "color"
      },
      contrast: {
        value: "#171717",
        type: "color"
      },
      main08: {
        value: "#5BB85F08",
        type: "color"
      },
      main30: {
        value: "#5BB85F30",
        type: "color"
      }
    },
    warning: {
      main: {
        value: "#DF8A43",
        type: "color"
      },
      dark: {
        value: "#C17935",
        type: "color"
      },
      light: {
        value: "#FFA559",
        type: "color"
      },
      contrast: {
        value: "#171717",
        type: "color"
      },
      main08: {
        value: "#DF8A4308",
        type: "color"
      },
      main30: {
        value: "#DF8A4330",
        type: "color"
      }
    },
    error: {
      main: {
        value: "#f66a5f",
        type: "color"
      },
      light: {
        value: "#f77d73",
        type: "color"
      },
      dark: {
        value: "#f44b3e",
        type: "color"
      },
      contrast: {
        value: "#171717",
        type: "color"
      },
      main08: {
        value: "#f66a5f08",
        type: "color"
      },
      main30: {
        value: "#f66a5f30",
        type: "color"
      }
    },
    background: {
      level1: {
        value: "#0c0c0c",
        type: "color"
      },
      level2: {
        value: "#1d1e20",
        type: "color"
      },
      level3: {
        value: "#282829",
        type: "color"
      },
      level4: {
        value: "#313338",
        type: "color"
      },
      white: {
        value: "#000000",
        type: "color"
      },
      black: {
        value: "#ffffff",
        type: "color"
      }
    }
  },
  elevation: {
    1: {
      value: [
        {
          color: "#00000008",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "8",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "20",
          spread: "0"
        },
        {
          color: "#00000005",
          type: "dropShadow",
          x: "0",
          y: "2",
          blur: "16",
          spread: "-1"
        }
      ],
      type: "boxShadow"
    },
    2: {
      value: [
        {
          color: "#00000014",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "5",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "2",
          blur: "8",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "1",
          spread: "-2"
        }
      ],
      type: "boxShadow"
    },
    3: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "16",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "4",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "11",
          spread: "-2"
        }
      ],
      type: "boxShadow"
    },
    4: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "10",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "4",
          blur: "5",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "2",
          blur: "4",
          spread: "-1"
        }
      ],
      type: "boxShadow"
    },
    5: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "14",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "8",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "8",
          spread: "-1"
        }
      ],
      type: "boxShadow"
    },
    6: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "18",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "10",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "5",
          spread: "-1"
        }
      ],
      type: "boxShadow"
    },
    7: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "2",
          blur: "16",
          spread: "1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "10",
          spread: "1"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "4",
          blur: "5",
          spread: "-2"
        }
      ],
      type: "boxShadow"
    },
    8: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "14",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "10",
          spread: "1"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "5",
          spread: "-3"
        }
      ],
      type: "boxShadow"
    },
    9: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "16",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "12",
          spread: "1"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "6",
          spread: "-3"
        }
      ],
      type: "boxShadow"
    },
    10: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "4",
          blur: "18",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "10",
          blur: "14",
          spread: "1"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "6",
          spread: "-3"
        }
      ],
      type: "boxShadow"
    },
    11: {
      value: [
        {
          color: "#0000001a",
          type: "dropShadow",
          x: "0",
          y: "4",
          blur: "20",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "11",
          blur: "15",
          spread: "1"
        },
        {
          color: "#00000026",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "16",
          spread: "-4"
        }
      ],
      type: "boxShadow"
    },
    12: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "22",
          spread: "4"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "12",
          blur: "17",
          spread: "2"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "8",
          spread: "-4"
        }
      ],
      type: "boxShadow"
    },
    13: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "24",
          spread: "4"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "13",
          blur: "19",
          spread: "2"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "8",
          spread: "-4"
        }
      ],
      type: "boxShadow"
    },
    14: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "26",
          spread: "4"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "14",
          blur: "21",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "9",
          spread: "-4"
        }
      ],
      type: "boxShadow"
    },
    15: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "28",
          spread: "5"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "15",
          blur: "22",
          spread: "2"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "9",
          spread: "-5"
        }
      ],
      type: "boxShadow"
    },
    16: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "30",
          spread: "5"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "16",
          blur: "24",
          spread: "2"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "10",
          spread: "-5"
        }
      ],
      type: "boxShadow"
    },
    17: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "32",
          spread: "5"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "17",
          blur: "26",
          spread: "2"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "11",
          spread: "-5"
        }
      ],
      type: "boxShadow"
    },
    18: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "34",
          spread: "6"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "18",
          blur: "28",
          spread: "2"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "11",
          spread: "-5"
        }
      ],
      type: "boxShadow"
    },
    19: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "36",
          spread: "6"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "19",
          blur: "29",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "12",
          spread: "-6"
        }
      ],
      type: "boxShadow"
    },
    20: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "38",
          spread: "7"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "20",
          blur: "31",
          spread: "3"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "10",
          blur: "13",
          spread: "-6"
        }
      ],
      type: "boxShadow"
    },
    21: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "40",
          spread: "7"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "21",
          blur: "33",
          spread: "3"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "10",
          blur: "13",
          spread: "-6"
        }
      ],
      type: "boxShadow"
    },
    22: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "42",
          spread: "7"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "22",
          blur: "35",
          spread: "3"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "10",
          blur: "14",
          spread: "-6"
        }
      ],
      type: "boxShadow"
    },
    23: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "44",
          spread: "8"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "23",
          blur: "36",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "11",
          blur: "14",
          spread: "-7"
        }
      ],
      type: "boxShadow"
    },
    24: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "46",
          spread: "8"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "24",
          blur: "38",
          spread: "3"
        },
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "11",
          blur: "15",
          spread: "-7"
        }
      ],
      type: "boxShadow"
    }
  },
  lineHeights: {
    0: {
      value: "100%",
      type: "lineHeights"
    },
    1: {
      value: "125%",
      type: "lineHeights"
    },
    2: {
      value: "150%",
      type: "lineHeights"
    },
    3: {
      value: "AUTO",
      type: "lineHeights"
    },
    100: {
      value: "100%",
      type: "lineHeights"
    },
    125: {
      value: "125%",
      type: "lineHeights"
    },
    150: {
      value: "150%",
      type: "lineHeights"
    },
    200: {
      value: "200%",
      type: "lineHeights"
    }
  },
  fontSize: {
    0: {
      value: "12",
      type: "fontSizes",
      oldValue: "11"
    },
    1: {
      value: "14",
      type: "fontSizes",
      oldValue: "12"
    },
    2: {
      value: "16",
      type: "fontSizes",
      oldValue: "14"
    },
    3: {
      value: "18",
      type: "fontSizes",
      oldValue: "16"
    },
    4: {
      value: "24",
      type: "fontSizes",
      oldValue: "18"
    },
    5: {
      value: "32",
      type: "fontSizes",
      oldValue: "20"
    },
    6: {
      value: "42",
      type: "fontSizes",
      oldValue: "24"
    },
    7: {
      value: "48",
      type: "fontSizes",
      oldValue: "26"
    },
    8: {
      value: "60",
      type: "fontSizes",
      oldValue: "32"
    },
    9: {
      value: "96",
      type: "fontSizes",
      oldValue: "42"
    },
    10: {
      value: "48",
      type: "fontSizes"
    },
    11: {
      value: "60",
      type: "fontSizes"
    },
    12: {
      value: "72",
      type: "fontSizes"
    },
    13: {
      value: "96",
      type: "fontSizes"
    },
    14: {
      value: "72",
      type: "fontSizes"
    },
    15: {
      value: "96",
      type: "fontSizes"
    },
    16: {
      value: "96",
      type: "fontSizes"
    }
  },
  letterSpacing: {
    0: {
      value: "-1.5",
      type: "letterSpacing"
    },
    1: {
      value: "-0.5",
      type: "letterSpacing"
    },
    2: {
      value: "-1%",
      type: "letterSpacing"
    },
    3: {
      value: "-2%",
      type: "letterSpacing",
      oldValue: "1%"
    },
    4: {
      value: "1%",
      type: "letterSpacing",
      oldValue: "-2%"
    },
    5: {
      value: "0%",
      type: "letterSpacing",
      oldValue: "0"
    },
    6: {
      value: "0",
      type: "letterSpacing",
      oldValue: "0%"
    },
    7: {
      value: "2%",
      type: "letterSpacing"
    },
    8: {
      value: "0.14",
      type: "letterSpacing"
    },
    9: {
      value: "0.15",
      type: "letterSpacing"
    },
    10: {
      value: "0.4",
      type: "letterSpacing"
    },
    11: {
      value: "0.16",
      type: "letterSpacing"
    },
    12: {
      value: "0.17",
      type: "letterSpacing"
    }
  },
  paragraphSpacing: {
    0: {
      value: "0",
      type: "paragraphSpacing"
    },
    1: {
      value: "11",
      type: "paragraphSpacing"
    },
    2: {
      value: "26",
      type: "paragraphSpacing"
    }
  },
  textCase: {
    none: {
      value: "none",
      type: "textCase"
    }
  },
  textDecoration: {
    none: {
      value: "none",
      type: "textDecoration"
    }
  },
  paragraphIndent: {
    0: {
      value: "0px",
      type: "dimension"
    }
  },
  fontWeights: {
    "inter-100": {
      value: "Thin",
      type: "fontWeights"
    },
    "inter-200": {
      value: "Extra Light",
      type: "fontWeights"
    },
    "inter-300": {
      value: "Light",
      type: "fontWeights"
    },
    "inter-400": {
      value: "Regular",
      type: "fontWeights"
    },
    "inter-500": {
      value: "Medium",
      type: "fontWeights"
    },
    "inter-600": {
      value: "Semi Bold",
      type: "fontWeights"
    },
    "inter-700": {
      value: "Bold",
      type: "fontWeights"
    },
    "inter-800": {
      value: "Extra Bold",
      type: "fontWeights"
    },
    "inter-900": {
      value: "Black",
      type: "fontWeights"
    },
    "inter-0": {
      value: "Bold",
      type: "fontWeights"
    },
    "inter-1": {
      value: "Semi Bold",
      type: "fontWeights"
    },
    "inter-2": {
      value: "Medium",
      type: "fontWeights"
    },
    "inter-3": {
      value: "Regular",
      type: "fontWeights"
    },
    "brockmann-4": {
      value: "Bold",
      type: "fontWeights"
    },
    "brockmann-5": {
      value: "SemiBold",
      type: "fontWeights"
    },
    "brockmann-6": {
      value: "Medium",
      type: "fontWeights"
    },
    "brockmann-7": {
      value: "Regular",
      type: "fontWeights"
    }
  },
  radius: {
    4: {
      value: "4",
      type: "borderRadius"
    },
    8: {
      value: "8",
      type: "borderRadius"
    },
    12: {
      value: "12",
      type: "borderRadius"
    },
    16: {
      value: "16",
      type: "borderRadius"
    },
    24: {
      value: "24",
      type: "borderRadius"
    },
    32: {
      value: "32",
      type: "borderRadius"
    },
    40: {
      value: "40",
      type: "borderRadius"
    },
    48: {
      value: "48",
      type: "borderRadius"
    },
    56: {
      value: "56",
      type: "borderRadius"
    },
    64: {
      value: "64",
      type: "borderRadius"
    },
    72: {
      value: "72",
      type: "borderRadius"
    },
    80: {
      value: "80",
      type: "borderRadius"
    }
  },
  spacing: {
    0: {
      value: "0",
      type: "spacing"
    },
    2: {
      value: "2",
      type: "spacing"
    },
    4: {
      value: "4",
      type: "spacing"
    },
    8: {
      value: "8",
      type: "spacing"
    },
    12: {
      value: "12",
      type: "spacing"
    },
    16: {
      value: "16",
      type: "spacing"
    },
    24: {
      value: "24",
      type: "spacing"
    },
    48: {
      value: "48",
      type: "spacing"
    }
  },
  fontFamilies: {
    inter: {
      value: "Inter",
      type: "fontFamilies"
    },
    brockmann: {
      value: "Brockmann",
      type: "fontFamilies"
    }
  },
  typography: {
    Display2XL: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-700}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.13}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-600}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.13}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-500}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.13}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-400}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.13}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      }
    },
    DisplayXL: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.8}",
          letterSpacing: "{letterSpacing.1}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-700}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.11}",
          letterSpacing: "{letterSpacing.1}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.8}",
          letterSpacing: "{letterSpacing.1}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-600}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.11}",
          letterSpacing: "{letterSpacing.1}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.8}",
          letterSpacing: "{letterSpacing.1}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-500}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.11}",
          letterSpacing: "{letterSpacing.1}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.8}",
          letterSpacing: "{letterSpacing.1}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-400}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.11}",
          letterSpacing: "{letterSpacing.1}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      }
    },
    DisplayLg: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-700}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-600}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-500}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-400}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      }
    },
    DisplayMd: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-700}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.8}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-600}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.8}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-500}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.8}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-400}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.8}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      }
    },
    DisplaySm: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-700}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.3}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-600}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.4}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.2}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-400}",
          lineHeight: "{lineHeights.150}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.2}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-500}",
          lineHeight: "{lineHeights.150}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      }
    },
    DisplayXs: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.4}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-700}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.3}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.4}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-600}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.3}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.4}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-400}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.3}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.4}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-500}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.3}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      }
    },
    TextMd: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.2}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-700}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.6}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.2}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-600}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.6}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.2}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-500}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.6}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.2}",
          letterSpacing: "{letterSpacing.6}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-400}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      }
    },
    TextSm: {
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.1}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-600}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.2}",
          letterSpacing: "{letterSpacing.6}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.1}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-700}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.2}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.1}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-400}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.2}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.1}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-500}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.2}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      }
    },
    TextXs: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.0}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-700}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.1}",
          letterSpacing: "{letterSpacing.6}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.0}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-600}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.1}",
          letterSpacing: "{letterSpacing.6}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.0}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-500}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.1}",
          letterSpacing: "{letterSpacing.6}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.0}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography",
        oldValue: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-400}",
          lineHeight: "{lineHeights.100}",
          fontSize: "{fontSize.1}",
          letterSpacing: "{letterSpacing.6}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        }
      }
    },
    Deprecated: {
      caption: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-400}",
          lineHeight: "{lineHeights.125}",
          fontSize: "{fontSize.0}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    Brand2XL: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-4}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-5}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-6}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-7}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    BrandXL: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-4}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.7}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-5}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.7}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-6}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.7}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-7}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.7}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    BrandLg: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-4}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-5}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-6}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-7}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    BrandMd: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-4}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-5}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-6}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-7}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    BrandSm: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-4}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-5}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-6}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-7}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    BrandXs: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-4}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-5}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-6}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-7}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    }
  },
  stennHub: {
    text: {
      primary: {
        value: "#303030",
        type: "color",
        description: "Text primary"
      },
      secondary: {
        value: "#707071",
        type: "color",
        description: "Text secondary"
      },
      tertiary: {
        value: "#8e8e8f",
        type: "color"
      },
      disabled: {
        value: "#9E9E9E",
        type: "color"
      },
      link: {
        value: "#3E26B3",
        type: "color"
      },
      body: {
        value: "#323232",
        type: "color"
      }
    },
    primary: {
      main: {
        value: "#21145F",
        type: "color"
      },
      light: {
        value: "#3E26B3",
        type: "color",
        description: "Alternative light shade"
      },
      dark: {
        value: "#120B35",
        type: "color"
      },
      contrast: {
        value: "#ffffff",
        type: "color",
        description: "Color that keeps a contrast ratio above AA when XX.main is used as a bg. color"
      },
      main30: {
        value: "#BCB8CF",
        type: "color",
        description: "Fill background for contained variant components in hover state."
      },
      main08: {
        value: "#EDECF2",
        type: "color",
        description: "Fill background color for outlined & text variant components in hover state (Button, etc)"
      }
    },
    secondary: {
      main: {
        value: "#393939",
        type: "color",
        description: "Secondary color used by most components"
      },
      light: {
        value: "#6b6b6b",
        type: "color",
        description: "Alternative light shade"
      },
      dark: {
        value: "#1b1b1b",
        type: "color",
        description: "Alternative dark shade"
      },
      contrast: {
        value: "#ffffff",
        type: "color",
        description: "Color that keeps a contrast ratio above AA when XX.main is used as a bg. color"
      },
      main30: {
        value: "#C4C4C4",
        type: "color",
        description: "Fill background for contained variant components in hover state (Button, FAB, etc)"
      },
      main08: {
        value: "#EFEFEF",
        type: "color",
        description: "Fill background color for outlined & text variant components in hover state (Button, etc)"
      }
    },
    background: {
      level1: {
        value: "#F8F8F8",
        type: "color"
      },
      level2: {
        value: "#EFEFEF",
        type: "color"
      },
      level3: {
        value: "#Ffffff",
        type: "color"
      },
      level4: {
        value: "#F0F0F0",
        type: "color"
      },
      white: {
        value: "#ffffff",
        type: "color"
      },
      black: {
        value: "#000000",
        type: "color"
      }
    },
    grey: {
      50: {
        value: "#F9F9F9",
        type: "color"
      },
      100: {
        value: "#f5f5f5",
        type: "color"
      },
      200: {
        value: "#eeeeee",
        type: "color"
      },
      300: {
        value: "#e0e0e0",
        type: "color"
      },
      400: {
        value: "#bdbdbd",
        type: "color"
      },
      500: {
        value: "#9e9e9e",
        type: "color"
      },
      600: {
        value: "#757575",
        type: "color"
      },
      700: {
        value: "#616161",
        type: "color"
      },
      800: {
        value: "#424242",
        type: "color"
      },
      900: {
        value: "#212121",
        type: "color"
      }
    },
    info: {
      main: {
        value: "#2196f3",
        type: "color",
        description: "Used for alert component"
      },
      light: {
        value: "#64b6f7",
        type: "color",
        description: "Alternative light shade"
      },
      dark: {
        value: "#0b79d0",
        type: "color",
        description: "Alternative dark shade"
      },
      contrast: {
        value: "#ffffff",
        type: "color",
        description: "Color that keeps a contrast ratio above AA when XX.main is used as a bg. color"
      },
      main30: {
        value: "#BCDFFB",
        type: "color",
        description: "Fill background color for contained variant components in hover state (Button, FAB, etc)"
      },
      main08: {
        value: "#EDF7FE",
        type: "color",
        description: "Used for outlined variant components in resting state (Button, Chip, etc)"
      }
    },
    success: {
      main: {
        value: "#4CA450",
        type: "color",
        description: "Used for alert component"
      },
      dark: {
        value: "#006644",
        type: "color",
        description: "Alternative dark shade"
      },
      light: {
        value: "#36B37E",
        type: "color",
        description: "Alternative light shade"
      },
      contrast: {
        value: "#ffffff",
        type: "color",
        description: "Color that keeps a contrast ratio above AA when XX.main is used as a bg. color"
      },
      main30: {
        value: "#C9E7CA",
        type: "color",
        description: "Fill background color for contained variant components in hover state (Button, FAB, etc)"
      },
      main08: {
        value: "#F1F9F1",
        type: "color",
        description: "Used for outlined variant components in resting state (Button, Chip, etc)"
      }
    },
    warning: {
      main: {
        value: "#FF8811",
        type: "color",
        description: "Used for alert component (изменил)"
      },
      dark: {
        value: "#CC6600",
        type: "color",
        description: "Alternative dark shade"
      },
      light: {
        value: "#FFB450",
        type: "color",
        description: "Alternative light shade"
      },
      contrast: {
        value: "#ffffff",
        type: "color",
        description: "Color that keeps a contrast ratio above AA when XX.main is used as a bg. color"
      },
      main30: {
        value: "#FFDBB8",
        type: "color",
        description: "Fill background color for contained variant components in hover state (Button, FAB, etc)"
      },
      main08: {
        value: "#FFF5EC",
        type: "color",
        description: "Used for outlined variant components in resting state (Button, Chip, etc)"
      }
    },
    error: {
      main: {
        value: "#D62839",
        type: "color",
        description: "Used for alert component"
      },
      dark: {
        value: "#AC202E",
        type: "color",
        description: "Alternative dark shade"
      },
      light: {
        value: "#F14F5A",
        type: "color",
        description: "Alternative light shade"
      },
      contrast: {
        value: "#ffffff",
        type: "color",
        description: "Color that keeps a contrast ratio above AA when XX.main is used as a bg. color"
      },
      main30: {
        value: "#F3BEC4",
        type: "color",
        description: "Fill background color for contained variant components in hover state (Button, FAB, etc)"
      },
      main08: {
        value: "#FCEEEF",
        type: "color",
        description: "Fill background color for outlined & text variant components in hover state (Button, etc)"
      }
    },
    other: {
      divider: {
        value: "#00000015",
        type: "color",
        description: "Divider fill color"
      },
      outlinedBorder: {
        value: "#00000023",
        type: "color",
        description: "Border style for outlined variant components in resting state (Text Field, Select, Chips, etc)"
      },
      backdropOverlay: {
        value: "#00000050",
        type: "color",
        description: "Backdrop overlay style"
      },
      filledInputBackground: {
        value: "#00000009",
        type: "color"
      },
      standardInputLine: {
        value: "#00000042",
        type: "color",
        description: "Border style for standard variant Text Field & Select"
      },
      snackbarBackground: {
        value: "#323232",
        type: "color",
        description: "Snackbar background color"
      },
      ratingActive: {
        value: "#ffb400",
        type: "color",
        description: "Active state color for Rating component"
      }
    },
    action: {
      active: {
        value: "#00000040",
        type: "color",
        description: "Fill color for components in active state (List, Table, etc)"
      },
      hover: {
        value: "#00000004",
        type: "color",
        description: "Fill background for components in hover state (List, Table, etc)"
      },
      selected: {
        value: "#00000008",
        type: "color",
        description: "Fill background for components in selected state (List, Table, etc)"
      },
      disabled: {
        value: "#00000015",
        type: "color",
        description: "Content color for components in disabled state (Button, List, Table, etc)"
      },
      disabledBackground: {
        value: "#b8b6c222",
        type: "color",
        description: "Fill background for components in disabled state (List, Table, etc)"
      },
      focus: {
        value: "#00000012",
        type: "color",
        description: "Fill background for components in focus state (List, Table, etc)"
      }
    }
  },
  shadow: {
    xsmall: {
      value: [
        {
          x: "0",
          y: "1",
          blur: "2",
          spread: "0",
          color: "#10182804",
          type: "dropShadow"
        },
        {
          x: "0",
          y: "1",
          blur: "2",
          spread: "0",
          color: "#10182804",
          type: "dropShadow"
        }
      ],
      type: "boxShadow"
    },
    small: {
      value: {
        x: "0",
        y: "2",
        blur: "6",
        spread: "0",
        color: "#10182806",
        type: "dropShadow"
      },
      type: "boxShadow"
    },
    medium: {
      value: [
        {
          x: "0",
          y: "6",
          blur: "15",
          spread: "-2",
          color: "#10182808",
          type: "dropShadow"
        },
        {
          x: "0",
          y: "6",
          blur: "15",
          spread: "-2",
          color: "#10182808",
          type: "dropShadow"
        }
      ],
      type: "boxShadow"
    },
    large: {
      value: [
        {
          x: "0",
          y: "8",
          blur: "24",
          spread: "-3",
          color: "#10182805",
          type: "dropShadow"
        },
        {
          x: "0",
          y: "8",
          blur: "24",
          spread: "-3",
          color: "#10182810",
          type: "dropShadow"
        }
      ],
      type: "boxShadow"
    },
    xlarge: {
      value: [
        {
          x: "0",
          y: "20",
          blur: "40",
          spread: "-8",
          color: "#10182805",
          type: "dropShadow"
        },
        {
          x: "0",
          y: "20",
          blur: "40",
          spread: "-8",
          color: "#10182810",
          type: "dropShadow"
        }
      ],
      type: "boxShadow"
    },
    xxlarge: {
      value: [
        {
          x: "0",
          y: "25",
          blur: "60",
          spread: "-15",
          color: "#10182812",
          type: "dropShadow"
        },
        {
          x: "0",
          y: "25",
          blur: "60",
          spread: "-15",
          color: "#10182820",
          type: "dropShadow"
        }
      ],
      type: "boxShadow"
    }
  },
  Shadows: {
    "shadow-xsmall": {
      value: [
        {
          color: "#1018280a",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "2",
          spread: "0"
        },
        {
          color: "#1018280a",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "2",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    "shadow-small": {
      value: {
        color: "#1018280f",
        type: "dropShadow",
        x: "0",
        y: "2",
        blur: "6",
        spread: "0"
      },
      type: "boxShadow"
    },
    "shadow-medium": {
      value: {
        color: "#10182814",
        type: "dropShadow",
        x: "0",
        y: "6",
        blur: "15",
        spread: "-2"
      },
      type: "boxShadow"
    },
    "shadow-large": {
      value: [
        {
          color: "#1018281a",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "24",
          spread: "-3"
        },
        {
          color: "#1018280d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "24",
          spread: "-3"
        }
      ],
      type: "boxShadow"
    },
    "shadow-xlarge": {
      value: [
        {
          color: "#1018281a",
          type: "dropShadow",
          x: "0",
          y: "20",
          blur: "40",
          spread: "-8"
        },
        {
          color: "#1018280d",
          type: "dropShadow",
          x: "0",
          y: "20",
          blur: "40",
          spread: "-8"
        }
      ],
      type: "boxShadow"
    },
    "shadow-xxlarge": {
      value: [
        {
          color: "#10182833",
          type: "dropShadow",
          x: "0",
          y: "25",
          blur: "60",
          spread: "-15"
        },
        {
          color: "#1018281f",
          type: "dropShadow",
          x: "0",
          y: "25",
          blur: "60",
          spread: "-15"
        }
      ],
      type: "boxShadow"
    }
  },
  Elevation: {
    1: {
      value: [
        {
          color: "#00000005",
          type: "dropShadow",
          x: "0",
          y: "2",
          blur: "16",
          spread: "-1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "20",
          spread: "0"
        },
        {
          color: "#00000008",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "8",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    2: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "1",
          spread: "-2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "2",
          blur: "8",
          spread: "0"
        },
        {
          color: "#00000014",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "5",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    3: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "11",
          spread: "-2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "4",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "16",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    4: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "2",
          blur: "4",
          spread: "-1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "4",
          blur: "5",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "10",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    5: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "8",
          spread: "-1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "8",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "14",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    6: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "5",
          spread: "-1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "10",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "18",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    7: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "4",
          blur: "5",
          spread: "-2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "10",
          spread: "1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "2",
          blur: "16",
          spread: "1"
        }
      ],
      type: "boxShadow"
    },
    8: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "5",
          spread: "-3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "10",
          spread: "1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "14",
          spread: "2"
        }
      ],
      type: "boxShadow"
    },
    9: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "6",
          spread: "-3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "12",
          spread: "1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "16",
          spread: "2"
        }
      ],
      type: "boxShadow"
    },
    10: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "6",
          spread: "-3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "10",
          blur: "14",
          spread: "1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "4",
          blur: "18",
          spread: "3"
        }
      ],
      type: "boxShadow"
    },
    11: {
      value: [
        {
          color: "#00000026",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "16",
          spread: "-4"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "11",
          blur: "15",
          spread: "1"
        },
        {
          color: "#0000001a",
          type: "dropShadow",
          x: "0",
          y: "4",
          blur: "20",
          spread: "3"
        }
      ],
      type: "boxShadow"
    },
    12: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "8",
          spread: "-4"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "12",
          blur: "17",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "22",
          spread: "4"
        }
      ],
      type: "boxShadow"
    },
    13: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "8",
          spread: "-4"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "13",
          blur: "19",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "24",
          spread: "4"
        }
      ],
      type: "boxShadow"
    },
    14: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "9",
          spread: "-4"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "14",
          blur: "21",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "26",
          spread: "4"
        }
      ],
      type: "boxShadow"
    },
    15: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "9",
          spread: "-5"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "15",
          blur: "22",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "28",
          spread: "5"
        }
      ],
      type: "boxShadow"
    },
    16: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "10",
          spread: "-5"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "16",
          blur: "24",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "30",
          spread: "5"
        }
      ],
      type: "boxShadow"
    },
    17: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "11",
          spread: "-5"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "17",
          blur: "26",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "32",
          spread: "5"
        }
      ],
      type: "boxShadow"
    },
    18: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "11",
          spread: "-5"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "18",
          blur: "28",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "34",
          spread: "6"
        }
      ],
      type: "boxShadow"
    },
    19: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "12",
          spread: "-6"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "19",
          blur: "29",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "36",
          spread: "6"
        }
      ],
      type: "boxShadow"
    },
    20: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "10",
          blur: "13",
          spread: "-6"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "20",
          blur: "31",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "38",
          spread: "7"
        }
      ],
      type: "boxShadow"
    },
    21: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "10",
          blur: "13",
          spread: "-6"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "21",
          blur: "33",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "40",
          spread: "7"
        }
      ],
      type: "boxShadow"
    },
    22: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "10",
          blur: "14",
          spread: "-6"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "22",
          blur: "35",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "42",
          spread: "7"
        }
      ],
      type: "boxShadow"
    },
    23: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "11",
          blur: "14",
          spread: "-7"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "23",
          blur: "36",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "44",
          spread: "8"
        }
      ],
      type: "boxShadow"
    },
    24: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "11",
          blur: "15",
          spread: "-7"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "24",
          blur: "38",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "46",
          spread: "8"
        }
      ],
      type: "boxShadow"
    }
  },
  FocusRing: {
    "FocusRing-Primary": {
      value: {
        color: "#f3f2ff",
        type: "dropShadow",
        x: "0",
        y: "0",
        blur: "0",
        spread: "4"
      },
      type: "boxShadow"
    },
    "FocusRing-Secondary": {
      value: {
        color: "#efefef",
        type: "dropShadow",
        x: "0",
        y: "0",
        blur: "0",
        spread: "4"
      },
      type: "boxShadow"
    },
    "FocusRing-Error": {
      value: {
        color: "#fef0ef",
        type: "dropShadow",
        x: "0",
        y: "0",
        blur: "0",
        spread: "4"
      },
      type: "boxShadow"
    }
  }
}, t = {
  Shadows: {
    "shadow-xsmall": {
      value: [
        {
          color: "#1018280a",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "2",
          spread: "0"
        },
        {
          color: "#1018280a",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "2",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    "shadow-small": {
      value: {
        color: "#1018280f",
        type: "dropShadow",
        x: "0",
        y: "2",
        blur: "6",
        spread: "0"
      },
      type: "boxShadow"
    },
    "shadow-medium": {
      value: {
        color: "#10182814",
        type: "dropShadow",
        x: "0",
        y: "6",
        blur: "15",
        spread: "-2"
      },
      type: "boxShadow"
    },
    "shadow-large": {
      value: [
        {
          color: "#1018281a",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "24",
          spread: "-3"
        },
        {
          color: "#1018280d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "24",
          spread: "-3"
        }
      ],
      type: "boxShadow"
    },
    "shadow-xlarge": {
      value: [
        {
          color: "#1018281a",
          type: "dropShadow",
          x: "0",
          y: "20",
          blur: "40",
          spread: "-8"
        },
        {
          color: "#1018280d",
          type: "dropShadow",
          x: "0",
          y: "20",
          blur: "40",
          spread: "-8"
        }
      ],
      type: "boxShadow"
    },
    "shadow-xxlarge": {
      value: [
        {
          color: "#10182833",
          type: "dropShadow",
          x: "0",
          y: "25",
          blur: "60",
          spread: "-15"
        },
        {
          color: "#1018281f",
          type: "dropShadow",
          x: "0",
          y: "25",
          blur: "60",
          spread: "-15"
        }
      ],
      type: "boxShadow"
    }
  },
  Elevation: {
    1: {
      value: [
        {
          color: "#00000005",
          type: "dropShadow",
          x: "0",
          y: "2",
          blur: "16",
          spread: "-1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "20",
          spread: "0"
        },
        {
          color: "#00000008",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "8",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    2: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "1",
          spread: "-2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "2",
          blur: "8",
          spread: "0"
        },
        {
          color: "#00000014",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "5",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    3: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "11",
          spread: "-2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "4",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "16",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    4: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "2",
          blur: "4",
          spread: "-1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "4",
          blur: "5",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "10",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    5: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "8",
          spread: "-1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "8",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "14",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    6: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "5",
          spread: "-1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "10",
          spread: "0"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "1",
          blur: "18",
          spread: "0"
        }
      ],
      type: "boxShadow"
    },
    7: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "4",
          blur: "5",
          spread: "-2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "10",
          spread: "1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "2",
          blur: "16",
          spread: "1"
        }
      ],
      type: "boxShadow"
    },
    8: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "5",
          spread: "-3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "10",
          spread: "1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "14",
          spread: "2"
        }
      ],
      type: "boxShadow"
    },
    9: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "6",
          spread: "-3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "12",
          spread: "1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "3",
          blur: "16",
          spread: "2"
        }
      ],
      type: "boxShadow"
    },
    10: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "6",
          spread: "-3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "10",
          blur: "14",
          spread: "1"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "4",
          blur: "18",
          spread: "3"
        }
      ],
      type: "boxShadow"
    },
    11: {
      value: [
        {
          color: "#00000026",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "16",
          spread: "-4"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "11",
          blur: "15",
          spread: "1"
        },
        {
          color: "#0000001a",
          type: "dropShadow",
          x: "0",
          y: "4",
          blur: "20",
          spread: "3"
        }
      ],
      type: "boxShadow"
    },
    12: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "8",
          spread: "-4"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "12",
          blur: "17",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "22",
          spread: "4"
        }
      ],
      type: "boxShadow"
    },
    13: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "8",
          spread: "-4"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "13",
          blur: "19",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "24",
          spread: "4"
        }
      ],
      type: "boxShadow"
    },
    14: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "9",
          spread: "-4"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "14",
          blur: "21",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "5",
          blur: "26",
          spread: "4"
        }
      ],
      type: "boxShadow"
    },
    15: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "9",
          spread: "-5"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "15",
          blur: "22",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "28",
          spread: "5"
        }
      ],
      type: "boxShadow"
    },
    16: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "10",
          spread: "-5"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "16",
          blur: "24",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "30",
          spread: "5"
        }
      ],
      type: "boxShadow"
    },
    17: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "11",
          spread: "-5"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "17",
          blur: "26",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "6",
          blur: "32",
          spread: "5"
        }
      ],
      type: "boxShadow"
    },
    18: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "11",
          spread: "-5"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "18",
          blur: "28",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "34",
          spread: "6"
        }
      ],
      type: "boxShadow"
    },
    19: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "12",
          spread: "-6"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "19",
          blur: "29",
          spread: "2"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "7",
          blur: "36",
          spread: "6"
        }
      ],
      type: "boxShadow"
    },
    20: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "10",
          blur: "13",
          spread: "-6"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "20",
          blur: "31",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "38",
          spread: "7"
        }
      ],
      type: "boxShadow"
    },
    21: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "10",
          blur: "13",
          spread: "-6"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "21",
          blur: "33",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "40",
          spread: "7"
        }
      ],
      type: "boxShadow"
    },
    22: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "10",
          blur: "14",
          spread: "-6"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "22",
          blur: "35",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "8",
          blur: "42",
          spread: "7"
        }
      ],
      type: "boxShadow"
    },
    23: {
      value: [
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "11",
          blur: "14",
          spread: "-7"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "23",
          blur: "36",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "44",
          spread: "8"
        }
      ],
      type: "boxShadow"
    },
    24: {
      value: [
        {
          color: "#00000033",
          type: "dropShadow",
          x: "0",
          y: "11",
          blur: "15",
          spread: "-7"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "24",
          blur: "38",
          spread: "3"
        },
        {
          color: "#0000000d",
          type: "dropShadow",
          x: "0",
          y: "9",
          blur: "46",
          spread: "8"
        }
      ],
      type: "boxShadow"
    }
  },
  fontFamilies: {
    inter: {
      value: "Inter",
      type: "fontFamilies"
    },
    brockmann: {
      value: "Brockmann",
      type: "fontFamilies"
    }
  },
  lineHeights: {
    0: {
      value: "100%",
      type: "lineHeights"
    },
    1: {
      value: "125%",
      type: "lineHeights"
    },
    2: {
      value: "150%",
      type: "lineHeights"
    },
    3: {
      value: "AUTO",
      type: "lineHeights"
    }
  },
  fontWeights: {
    "inter-0": {
      value: "Bold",
      type: "fontWeights"
    },
    "inter-1": {
      value: "Semi Bold",
      type: "fontWeights"
    },
    "inter-2": {
      value: "Medium",
      type: "fontWeights"
    },
    "inter-3": {
      value: "Regular",
      type: "fontWeights"
    },
    "brockmann-4": {
      value: "Bold",
      type: "fontWeights"
    },
    "brockmann-5": {
      value: "SemiBold",
      type: "fontWeights"
    },
    "brockmann-6": {
      value: "Medium",
      type: "fontWeights"
    },
    "brockmann-7": {
      value: "Regular",
      type: "fontWeights"
    }
  },
  fontSize: {
    0: {
      value: "12",
      type: "fontSizes"
    },
    1: {
      value: "14",
      type: "fontSizes"
    },
    2: {
      value: "16",
      type: "fontSizes"
    },
    3: {
      value: "18",
      type: "fontSizes"
    },
    4: {
      value: "24",
      type: "fontSizes"
    },
    5: {
      value: "32",
      type: "fontSizes"
    },
    6: {
      value: "42",
      type: "fontSizes"
    },
    7: {
      value: "48",
      type: "fontSizes"
    },
    8: {
      value: "60",
      type: "fontSizes"
    },
    9: {
      value: "96",
      type: "fontSizes"
    }
  },
  letterSpacing: {
    0: {
      value: "-1.5",
      type: "letterSpacing"
    },
    1: {
      value: "-0.5",
      type: "letterSpacing"
    },
    2: {
      value: "-1%",
      type: "letterSpacing"
    },
    3: {
      value: "-2%",
      type: "letterSpacing"
    },
    4: {
      value: "1%",
      type: "letterSpacing"
    },
    5: {
      value: "0%",
      type: "letterSpacing"
    },
    6: {
      value: "0",
      type: "letterSpacing"
    }
  },
  paragraphSpacing: {
    0: {
      value: "0",
      type: "paragraphSpacing"
    }
  },
  typography: {
    Display2XL: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    DisplayXL: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.8}",
          letterSpacing: "{letterSpacing.1}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.8}",
          letterSpacing: "{letterSpacing.1}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.8}",
          letterSpacing: "{letterSpacing.1}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.8}",
          letterSpacing: "{letterSpacing.1}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    DisplayLg: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    DisplayMd: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    DisplaySm: {
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.2}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.3}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.2}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    DisplayXs: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.4}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.4}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.4}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.4}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    TextMd: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.2}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.2}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.2}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.2}",
          letterSpacing: "{letterSpacing.6}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    TextSm: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.1}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.1}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.1}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.1}",
          fontSize: "{fontSize.1}",
          letterSpacing: "{letterSpacing.2}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    TextXs: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.0}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.0}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.0}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.0}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    Brand2XL: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-0}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-1}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-2}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.inter}",
          fontWeight: "{fontWeights.inter-3}",
          lineHeight: "{lineHeights.0}",
          fontSize: "{fontSize.9}",
          letterSpacing: "{letterSpacing.0}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    BrandXL: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-4}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.7}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-5}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.7}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-6}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.7}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-7}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.7}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    BrandLg: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-4}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-5}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-6}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-7}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.6}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    BrandMd: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-4}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-5}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-6}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-7}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.5}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    BrandSm: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-4}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-5}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-6}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-7}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.4}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    },
    BrandXs: {
      Bold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-4}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      SemiBold: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-5}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Medium: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-6}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      },
      Regular: {
        value: {
          fontFamily: "{fontFamilies.brockmann}",
          fontWeight: "{fontWeights.brockmann-7}",
          lineHeight: "{lineHeights.3}",
          fontSize: "{fontSize.3}",
          letterSpacing: "{letterSpacing.5}",
          paragraphSpacing: "{paragraphSpacing.0}",
          paragraphIndent: "{paragraphIndent.0}",
          textCase: "{textCase.none}",
          textDecoration: "{textDecoration.none}"
        },
        type: "typography"
      }
    }
  },
  textCase: {
    none: {
      value: "none",
      type: "textCase"
    }
  },
  textDecoration: {
    none: {
      value: "none",
      type: "textDecoration"
    }
  },
  paragraphIndent: {
    0: {
      value: "0px",
      type: "dimension"
    }
  }
}, a = [], n = {
  tokenSetOrder: [
    "brand",
    "Test",
    "Radius/Mode 1",
    "Spacing/Mode 1"
  ]
}, o = {
  brand: e,
  Test: t,
  "Radius/Mode 1": {
    "radius-4": {
      value: "4",
      type: "number",
      parent: "Radius/Mode 1",
      description: ""
    },
    "radius-8": {
      value: "8",
      type: "number",
      parent: "Radius/Mode 1",
      description: ""
    },
    "radius-12": {
      value: "12",
      type: "number",
      parent: "Radius/Mode 1",
      description: ""
    },
    "radius-16": {
      value: "16",
      type: "number",
      parent: "Radius/Mode 1",
      description: ""
    },
    "radius-24": {
      value: "24",
      type: "number",
      parent: "Radius/Mode 1",
      description: ""
    },
    "radius-32": {
      value: "32",
      type: "number",
      parent: "Radius/Mode 1",
      description: ""
    },
    "radius-40": {
      value: "40",
      type: "number",
      parent: "Radius/Mode 1",
      description: ""
    },
    "radius-48": {
      value: "48",
      type: "number",
      parent: "Radius/Mode 1",
      description: ""
    },
    "radius-56": {
      value: "56",
      type: "number",
      parent: "Radius/Mode 1",
      description: ""
    },
    "radius-64": {
      value: "64",
      type: "number",
      parent: "Radius/Mode 1",
      description: ""
    },
    "radius-72": {
      value: "72",
      type: "number",
      parent: "Radius/Mode 1",
      description: ""
    },
    "radius-80": {
      value: "80",
      type: "number",
      parent: "Radius/Mode 1",
      description: ""
    }
  },
  "Spacing/Mode 1": {
    "spacing-0": {
      value: "0",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-2": {
      value: "2",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-4": {
      value: "4",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-8": {
      value: "8",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-12": {
      value: "12",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-16": {
      value: "16",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-24": {
      value: "24",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-48": {
      value: "48",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-32": {
      value: "32",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-20": {
      value: "20",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-28": {
      value: "28",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-40": {
      value: "40",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-64": {
      value: "64",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-80": {
      value: "80",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-96": {
      value: "96",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-128": {
      value: "128",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-160": {
      value: "160",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    },
    "spacing-192": {
      value: "192",
      type: "number",
      parent: "Spacing/Mode 1",
      description: ""
    }
  },
  $themes: a,
  $metadata: n
};
export {
  n as $metadata,
  a as $themes,
  t as Test,
  e as brand,
  o as default
};
//# sourceMappingURL=tokens.json.mjs.map
